module.exports = "/templates/tasks.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/tasks.html
// module id = 472
// module chunks = 0